// =============================================================
// Firebase client SDK initialization
// =============================================================
// All config values come from /app/frontend/.env (REACT_APP_FIREBASE_*)
// To rotate keys: update the .env file and restart the frontend.
//
// Services initialized here:
//   • Authentication (Email/Password + Google provider)
//   • Cloud Firestore (per-user collections under /users/{uid}/...)
//   • Cloud Storage  (tournament photos under /tournaments/{uid}/...)
//
// Security model: enforced server-side by /firestore.rules and
// /storage.rules — see those files for the per-user access matrix.
// =============================================================

import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Guard against double-init during hot reload.
export const firebaseApp = getApps()[0] || initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);
// Keep users signed in across browser restarts (default, but explicit).
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.error("Failed to set auth persistence", err);
});

export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
